<template>

  <img
      class="routeleaf-logo"
      alt="RouteLeaf Logo"
      :width="width"
      :src="require('@/assets/img/routeleaf-logo-text-white.svg')"
      @click="handleClick" />

</template>

<script>
export default {
  name: 'RouteLeafLogo',

  props: {
    width: {
      type: String,
      default: '140px'
    },
    linkTo: {
      type: String,
      default: 'home'
    }
  },

  methods: {
    handleClick () {
      if (this.linkTo) this.$root.goTo(this.linkTo)
    }
  }
}
</script>

<style>
  .routeleaf-logo {
    cursor: pointer;
  }
</style>
